
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rewards/leaderboard",
      function () {
        return require("private-next-pages/rewards/leaderboard.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rewards/leaderboard"])
      });
    }
  